<template>
    <v-card class="pa-2">
        <v-card-title>
            <h2 style="text-align: center; width: 100%;">Recebimento pela Carteira</h2>
        </v-card-title>
        <v-card-text>
            <h4 class="text-xs-center">Informações do Solicitante</h4>
            <v-layout wrap justify-spacer-around>
                <v-flex xs5>
                    Nome Fantasia: <b>{{posto.nome_fantasia}}</b>
                </v-flex>
                <v-flex xs5>
                    CNPJ: <b>{{posto.cnpj}}</b>
                </v-flex>
                <v-flex xs10>
                    Razão Social: <b>{{posto.razao_social}}</b>
                </v-flex>
                 <v-flex xs10>
                    Nome do representante: <b>{{posto.representante.nome_completo}}</b>
                </v-flex>
                <v-flex xs5>
                    E-mail: <b>{{posto.representante.email}}</b>
                </v-flex>
                <v-flex xs5>
                    Telefone: <b>{{posto.representante.telefone}}</b>
                </v-flex>
                <v-flex class="mt-4" xs12 style="font-size: 1.2em">
                    O posto {{posto.nome_fantasia.replace('Posto', '')}} desejar receber pela carteira sobre as vendas para a
                    {{ posto.tem_recebimento_carteira_empresa ? 'empresas' : '' }}
                    {{posto.tem_recebimento_carteira_cliente && posto.tem_recebimento_carteira_empresa ? ' e ': ''}}
                    {{ posto.tem_recebimento_carteira_cliente ? 'clientes' : '' }}.
                </v-flex>
                <v-layout justify-center class="mt-3" style="width: 100%;" v-if="!editar">
                    <v-btn round color="info" @click="editar = true">Editar taxas</v-btn>
                </v-layout>
                <v-flex xs12 v-if="editar && posto && posto.tem_recebimento_carteira_cliente" class="mt-3">
                  <v-text-field
                    v-model="taxa_recebimento_cliente"
                    outline
                    label="Taxa de recebimento por clientes"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="editar && posto && posto.tem_recebimento_carteira_empresa" class="mt-3">
                  <v-text-field
                    v-model="taxa_recebimento_empresa"
                    outline
                    label="Taxa de recebimento por empresa"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-layout justify-center class="mt-3" style="width: 100%;" v-if="editar">
                    <v-btn round color="info" @click="editar = false">Deixar taxas padrão</v-btn>
                </v-layout>
            </v-layout>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round class="mb-2" color="error" @click="responseContrato(false)">Rejeitar</v-btn>
            <v-btn round class="mb-2" color="success" @click="responseContrato(true)">Aceitar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['posto'],
    data: () => ({
        taxa_recebimento_cliente: 0,
        taxa_recebimento_empresa: 0,
        editar: false
    }),
    watch: {
        editar (val) {
            if (!val) {
                this.taxa_recebimento_cliente = undefined
                this.taxa_recebimento_empresa = undefined
            }
        }
    },
    methods: {
        responseContrato (resposta) {
            const data = {
                method: 'PUT',
                tipo: 'posto_carteira',
                cnpj: this.posto.cnpj,
                resposta: resposta
            }
            if (this.taxa_recebimento_cliente) data.taxa_recebimento_cliente = this.taxa_recebimento_cliente
            if (this.taxa_recebimento_cliente) data.taxa_recebimento_empresa = this.taxa_recebimento_empresa
            this.$store.dispatch('notificacoesAdmin', data).then(() => {
                this.$emit('success', 'Solicitação aceita com sucesso')
                this.$emit('carregar')
                this.$emit('fechar')
            }).catch(() => {
                this.$emit('error', 'Não foi possível aceitar solicitação.')
            })
        }
    }
}
</script>
